import "./HomePage.css";
import { Link } from "react-router-dom";
import { MsgSucess } from "../components/Shared";
import { useEffect } from "react";

export const HomePage = ({ message, setMessage }) => {
  useEffect(() => {
    setTimeout(() => {
      setMessage(null);
    }, 1000000);
  }, [message, setMessage]);

  return (
    <div className="wrap container">
      <div>
        {message && (
          <MsgSucess>
            <div
              className="msg-sucess-new"
              dangerouslySetInnerHTML={{ __html: message }}
            ></div>
          </MsgSucess>
        )}
      </div>
      <section className="container mb-3">
        <p className="p">Bem-vindo ao Canal de Denúncias 1RIGO</p>
        <p>
          Este é um canal exclusivo do Registro de Imóveis da 1ª Circunscrição
          de Goiânia-GO para comunicação segura e, se desejada, anônima, de
          condutas consideradas antiéticas ou que violem os nossos valores e/ou
          a legislação vigente.
        </p>
        <p>
          As informações aqui registradas serão recebidas pelo comitê de
          denúncias, assegurando sigilo absoluto e o tratamento adequado de cada
          situação pela alta administração do 1RIGO, sem conflitos de
          interesses.
        </p>
      </section>
      <section className="d-flex container wrap-site row mt-3">
        <Link to="/complaints" className="col-sm-12 col-md-6 col-lg-6">
          <div className="card-body">
            <p>
              <i className="bi bi-chat-right-quote"></i>
            </p>
            <p className="p">Faça uma denúncia</p>
            <span className="span">
              Você pode utilizar nosso formulário eletrônico.
            </span>
          </div>
        </Link>
        <Link to="/track-complaint" className="col-sm-12 col-md-6 col-lg-6">
          <div className="card-body">
            <p>
              <i className="bi bi-folder-plus"></i>
            </p>
            <p className="p">Acompanhe sua denúncia</p>
            <span className="span">
              Veja as últimas atualizações através do número de protocolo.
            </span>
          </div>
        </Link>
        {/*
        <Link to="/" className="col-sm-12 col-md-4 col-lg-4">
          <div className="card-body">
            <p>
              <i className="bi bi-patch-question"></i>
            </p>
            <p className="p">Como funciona o canal?</p>
            <span className="span">
              Conheça como funciona o canal de denúncia.
            </span>
          </div>
        </Link>
            */}
      </section>
    </div>
  );
};
